import { render, staticRenderFns } from "./DxBareRootTable.vue?vue&type=template&id=06812de4&"
import script from "./DxBareRootTable.vue?vue&type=script&lang=js&"
export * from "./DxBareRootTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports